import React from 'react';

import cn from 'classnames';
import { noop } from 'lodash';
import { string, shape, func, bool, oneOfType } from 'prop-types';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';

import ClickableComponent from 'components/Common/ClickableComponent';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import s from './PageDetails.css';

const PageDetails = ({
  module,
  title,
  modal,
  openModal,
  classes,
  onboardingFeaturePending,
}) => {
  const hasModal = Boolean(modal);

  return (
    <div
      className={cn(s.container, classes?.container, {
        [s.noModule]: !module,
      })}
      data-testid="page-details-indicator"
    >
      <div className={s.content}>
        {module && <span className={s.label}>{module}</span>}
        <h1 className={cn(s.title, classes?.title)}>{title}</h1>
      </div>
      {hasModal && (
        <ClickableComponent
          className={cn(s.modal, {
            [s.onboardingFeaturePending]: onboardingFeaturePending,
          })}
          onClick={openModal}
        >
          <FontAwesomeIcon icon={faCircleInfo} />
        </ClickableComponent>
      )}
    </div>
  );
};

PageDetails.propTypes = {
  modal: oneOfType([string, bool]),
  module: string,
  title: string,
  classes: shape({
    container: string,
    title: string,
  }),
  openModal: func,
  onboardingFeaturePending: bool,
};

PageDetails.defaultProps = {
  modal: null,
  module: '',
  classes: {
    container: '',
    title: '',
  },
  onboardingFeaturePending: false,
  title: null,
  openModal: noop,
};

export default PageDetails;
